import { useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Bewaart de volgorde van een overzicht (gefilterd + gesorteerd zoals getoond),
// zodat de detailpagina "vorige/volgende" in exact die volgorde kan doorlopen
// en "Terug" naar dezelfde tab/filter terugkeert.
export function slaOverzichtNavOp(key, ids, terug) {
  try {
    sessionStorage.setItem(`overzichtnav:${key}`, JSON.stringify({ ids, terug }));
  } catch { /* sessionStorage niet beschikbaar */ }
}

export function leesOverzichtNav(key, currentId) {
  let data = null;
  try { data = JSON.parse(sessionStorage.getItem(`overzichtnav:${key}`) || "null"); } catch { data = null; }
  const ids = Array.isArray(data?.ids) ? data.ids : [];
  const terug = data?.terug || null;
  if (!ids.length) return { vorige: null, volgende: null, positie: null, totaal: 0, terug };
  const i = ids.indexOf(currentId);
  if (i === -1) return { vorige: null, volgende: null, positie: null, totaal: ids.length, terug };
  return {
    vorige: i > 0 ? ids[i - 1] : null,
    volgende: i < ids.length - 1 ? ids[i + 1] : null,
    positie: i + 1,
    totaal: ids.length,
    terug,
  };
}

// Hook voor detailpagina's: geeft vorige/volgende in overzichtsvolgorde én
// koppelt de pijltjestoetsen ↑ (vorige, omhoog) / ↓ (volgende, omlaag).
// Typen in invoervelden blijft ongestoord.
export function useDetailNav(key, id, basePad) {
  const navigate = useNavigate();
  const nav = useMemo(() => leesOverzichtNav(key, id), [key, id]);
  const ref = useRef(nav);
  ref.current = nav;
  useEffect(() => {
    const onKey = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const t = e.target;
      const tag = (t?.tagName || "").toLowerCase();
      if (["input", "textarea", "select"].includes(tag) || t?.isContentEditable) return;
      const cur = ref.current;
      if (e.key === "ArrowDown" && cur.volgende) { e.preventDefault(); navigate(`${basePad}/${cur.volgende}`); }
      else if (e.key === "ArrowUp" && cur.vorige) { e.preventDefault(); navigate(`${basePad}/${cur.vorige}`); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate, basePad]);
  return nav;
}

// Alleen de pijltjestoetsen koppelen aan bestaande prev/next-targets
// (voor pagina's met eigen navigatielogica, zoals verkoopkansen).
export function usePijltjesNav(basePad, vorigeId, volgendeId) {
  const navigate = useNavigate();
  const ref = useRef({ vorigeId, volgendeId });
  ref.current = { vorigeId, volgendeId };
  useEffect(() => {
    const onKey = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const t = e.target;
      const tag = (t?.tagName || "").toLowerCase();
      if (["input", "textarea", "select"].includes(tag) || t?.isContentEditable) return;
      const cur = ref.current;
      if (e.key === "ArrowDown" && cur.volgendeId) { e.preventDefault(); navigate(`${basePad}/${cur.volgendeId}`); }
      else if (e.key === "ArrowUp" && cur.vorigeId) { e.preventDefault(); navigate(`${basePad}/${cur.vorigeId}`); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate, basePad]);
}
